import { makeStyles } from "@mui/styles";

const modelHeaderStyle = makeStyles((theme) => ({

    headerContainer: {
        paddingTop: "2rem",
        [theme.breakpoints.down('lg')]: {
            paddingTop:"1rem",
        },
        [theme.breakpoints.down('sm')]: {
            paddingLeft: "2.5rem",
            paddingRight: "2.5rem",
        },
    },

    header: {
        paddingTop: "1rem",
        color: theme.palette.text.primary,
        fontWeight: "bold",
        fontSize: "2rem",
        marginBottom: "2rem !important",
        [theme.breakpoints.down('lg')]: {
            paddingTop:"0rem",
        },
        [theme.breakpoints.down('sm')]: {
            textAlign: "center",
            fontSize: "2.1rem!important",
            paddingTop:"0.6rem",
            paddingBottom: "1.2rem",
        },
    },

    paragraph: {
        fontSize: "1.2rem !important",
        color: theme.palette.text.lightGray,
        marginBottom: "2.5rem !important",
        textAlign: "left",
        [theme.breakpoints.down('lg')]: {
            fontSize: "1.2rem !important",
            paddingTop:"1rem",
            textAlign: "justify",
        },
        [theme.breakpoints.down('sm')]: {
            textAlign: "justify",
            fontSize: "1.4rem !important",
        },
    },

}));

export default modelHeaderStyle;